import * as ko from 'knockout';

import { I18nText } from '../i18n_text';
import { CustomerProfileData } from '../api/customer_profiles';

export class CustomerProfile {
  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });

  constructor(data?: CustomerProfileData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
    }
  }

  toData(): CustomerProfileData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
    };
  }
}
